import React from 'react'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as commonStyles from '../../../../../common/_common.scss'
import AdviserProfileAreasOfSpecialisation from '../../../../../common/AdviserProfiles/AdviserProfileAreasOfSpecialisation'
import * as styles from './_AdviserProfileAreasOfSpecialisationEditor.scss'
import { connect } from 'react-redux'
import { FormCheck } from 'react-bootstrap'
import {
  startEditingAreasOfSpecialisation
  , stopEditingAreasOfSpecialisation
  , cancelEditingAreasOfSpecialisation
  , fetchAreasOfSpecialisation
  , areaOfSpecialisationSelectedChanged
} from './adviserProfileAreasOfSpecialisationEditorActions'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types';

class adviserProfileAreasOfSpecialisationEditorActions extends React.Component {
  static propTypes = {
    profile: PropTypes.object.isRequired,
    editingAreasOfSpecialisation: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    startEditingAreasOfSpecialisation: PropTypes.func.isRequired,
    stopEditingAreasOfSpecialisation: PropTypes.func.isRequired,
    cancelEditingAreasOfSpecialisation: PropTypes.func.isRequired,
    fetchAreasOfSpecialisation: PropTypes.func.isRequired,
    allAreasOfSpecialisation: PropTypes.array.isRequired,
    areasOfSpecialisationWithChanges: PropTypes.array.isRequired,
    areaOfSpecialisationSelectedChanged: PropTypes.func.isRequired,
    formIsValid: PropTypes.bool.isRequired,
    value: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.number
        ]),
    isInvalid: PropTypes.object,
    message: PropTypes.string,
  };

  constructor (props) {
    super(props)
    this.stopEditingAreasOfSpecialisation = this.stopEditingAreasOfSpecialisation.bind(this)
  }

  componentDidMount () {
    this.props.fetchAreasOfSpecialisation()
  }

  stopEditingAreasOfSpecialisation () {
    this.props.stopEditingAreasOfSpecialisation()
  }

  render () {
    const profile = this.props.profile
    const editingAreasOfSpecialisation = this.props.editingAreasOfSpecialisation
    const selectedAreasOfSpecialisation = profile.financialServicesOffered

    if (editingAreasOfSpecialisation) {

const allAreasOfSpecialisation =
  this.props.allAreasOfSpecialisation.map(areaOfSpecialisation => ({
    ...areaOfSpecialisation,
    selected: selectedAreasOfSpecialisation.some(
      selectedAreaOfSpecialisation =>
        selectedAreaOfSpecialisation.financialServiceId ===
        areaOfSpecialisation.financialServiceId
    )
  }))
      return <div>
        <h4 className={styles['title']}>Services Offered</h4>
        <form className={styles['form-bottom-margin']}>
          {allAreasOfSpecialisation.map((areaOfSpecialisation) => {
            return <FormCheck
              key={areaOfSpecialisation.financialServiceId}
              type="checkbox"
              checked={areaOfSpecialisation.selected}
              value={areaOfSpecialisation.financialServiceId}
              onChange={() => {
                this.props.areaOfSpecialisationSelectedChanged(areaOfSpecialisation)
              }}
              label={areaOfSpecialisation.name}
            />

          })}
        </form>
      </div>
    }

const specializationsWithClasses =
  this.props.areasOfSpecialisationWithChanges.map(area => {
    let className = ''

    if (area.modificationState === 'deleted') {
      className = commonStyles['item-deleted']
    }

    if (area.modificationState === 'added') {
      className = commonStyles['item-added']
    }

    return {
      ...area,
      className
    }
  })
    return <div>
      <AdviserProfileAreasOfSpecialisation areas={specializationsWithClasses} />
    </div>
  }
}

const mapStateToProps = ({adviserProfileApprovalEditorContainer}) => {
  return {
    editingAreasOfSpecialisation: adviserProfileApprovalEditorContainer.areasOfSpecialisation.editingAreasOfSpecialisation,
    loading: adviserProfileApprovalEditorContainer.areasOfSpecialisation.loadingAreasOfSpecialisation,
    formIsValid: adviserProfileApprovalEditorContainer.areasOfSpecialisation.isInvalid.formIsValid,
    isInvalid: adviserProfileApprovalEditorContainer.areasOfSpecialisation.isInvalid,
    allAreasOfSpecialisation: adviserProfileApprovalEditorContainer.areasOfSpecialisation.allAreasOfSpecialisation,
    areasOfSpecialisationWithChanges: adviserProfileApprovalEditorContainer.areasOfSpecialisation.profileModifications
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    startEditingAreasOfSpecialisation: startEditingAreasOfSpecialisation,
    stopEditingAreasOfSpecialisation: stopEditingAreasOfSpecialisation,
    cancelEditingAreasOfSpecialisation: cancelEditingAreasOfSpecialisation,
    fetchAreasOfSpecialisation: fetchAreasOfSpecialisation,
    areaOfSpecialisationSelectedChanged: areaOfSpecialisationSelectedChanged
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)( (adviserProfileAreasOfSpecialisationEditorActions))
